import React, { FC, Fragment, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { Data } from '../../../database.schema';
import { FlexRowCentred, FlexRowSpaceEvenly } from '../common-styles/common-styles';
import * as CSS from './team-name-styles';
import { TeamNameEntry } from './team-name-entry';
import { useFetchData } from '../../api/tournament-data';
import { SelectedIndexContext } from '../../App';

export const TeamNames: FC = () => {
  const navigate = useNavigate();
  const { data } = useFetchData((data) => data);

  const { selectedTournamentIndex } = useContext(SelectedIndexContext);
  const dataResolved = data as Data;
  const tournaments = dataResolved.tournaments;

  const tournament = tournaments[selectedTournamentIndex]?.ryderCup;
  if (tournament?.team1 && tournament?.team2) {
    return (
      <Fragment>
        <h2>Team Names</h2>
        <FlexRowSpaceEvenly>
          <TeamNameEntry colour="red" teamNumber={1} teamDetails={tournament.team1} tournamentIndex={selectedTournamentIndex} />
          <TeamNameEntry colour="blue" teamNumber={2} teamDetails={tournament.team2} tournamentIndex={selectedTournamentIndex} />
        </FlexRowSpaceEvenly>
        <FlexRowCentred>
          <CSS.Button data-testid="finish-button" onClick={() => navigate('/')}>
            Done
          </CSS.Button>
        </FlexRowCentred>
      </Fragment>
    );
  }

  return <div>Not Ryder up</div>;
};
